// src/components/TopNavigation.js
import React from "react";
import { FaMusic, FaCamera, FaFilm } from "react-icons/fa";

function TopNavigation({ setActiveSection }) {
  return (
    <nav className="bg-[#2f1c52] text-white py-1 flex justify-around items-center fixed top-0 left-0 w-full z-10">
      <div className="cursor-pointer" onClick={() => setActiveSection("Bio")}>
        <img
          src="/assets/images/caseboldtmusic.png"
          alt="Caseboldt Logo"
          className="h-[42px]"
        />
      </div>
      <div className="flex space-x-12">
        <FaMusic
          className="text-xl cursor-pointer"
          title="Music"
          onClick={() => setActiveSection("Music")}
        />
        <FaCamera
          className="text-xl cursor-pointer"
          title="Photo"
          onClick={() => setActiveSection("Photo")}
        />
        <FaFilm
          className="text-xl cursor-pointer"
          title="Video"
          onClick={() => setActiveSection("Video")}
        />
      </div>
    </nav>
  );
}

export default TopNavigation;
